import { trpc } from "@/lib/trpc";
import { useAuth } from "@/lib/auth";
import { linkDoCatalogo } from "@/lib/link-do-catalogo";

/** Link público do catálogo do laboratório ativo, ou nulo (desligado, ou não é laboratório) —
 *  é o que as etiquetas usam pro QR do catálogo. */
export function useLinkDoCatalogo(): string | null {
  const { user } = useAuth();
  const ehLab = !!user?.activeOrganization?.types?.includes("DENTAL_LAB");
  const codigo = trpc.catalogoPublico.configuracao.useQuery(undefined, { enabled: ehLab }).data?.codigo;
  return codigo ? linkDoCatalogo(codigo) : null;
}
